import Icon from '@ant-design/icons';
import { Tabs as TabsBase } from 'antd';
import styled from 'styled-components';

export const SupportIcon = styled(Icon)``;

export const SupportWrapper = styled.div`
  padding: 5px 8px;
  border-radius: 4px;
  &:hover {
    background: #ced9e0;
  }
`;

export const Tabs = styled(TabsBase)`
  .ant-tabs-nav {
    margin-bottom: 0;
  }
  .ant-tabs-nav-wrap {
    margin-right: 16px;
    margin-left: 16px;
  }

  .ant-tabs-content-holder {
    padding: 8px;
  }
`;
